import {
  Box,
  Button,
  Grid2,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { links, primaryColor, secondaryColor } from "../constants/constants";
import { logo3 } from "../assets/assets";
import { Link } from "react-router-dom";
import styled from "styled-components";
import useScreenSize from "../hooks/useScreenSize";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    background: "rgb(232, 241, 250) !important",
    paddingRight: 0,
    input: {
      paddingTop: "10px",
      paddingBottom: "10px",
    },
    "& .Mui-focused fieldset": {
      borderColor: "white",
    },
  },
}));

const Footer = () => {
  const { isGreaterThanOrEqualMd } = useScreenSize();
  return (
    <>
      <Box
        sx={{ background: primaryColor, color: "white", padding: "30px 25px" }}
      >
        <Grid2 container maxWidth="lg" sx={{ margin: "auto" }}>
          {isGreaterThanOrEqualMd && (
            <Grid2
              size={{ md: 3 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={logo3} style={{ width: "100px" }} />
            </Grid2>
          )}
          <Grid2
            size={{ xs: 12, md: 3 }}
            sx={{
              display: isGreaterThanOrEqualMd ? "flex" : "none",
              justifyContent: "center",
              alignItems: "center",
              gap: 5,
              fontWeight: 500,
            }}
          >
            <Stack spacing={1.5}>
              {links.map((item, index) => {
                if (index > 2) {
                  return;
                }
                return (
                  <Box>
                    <Link to={item.link} style={{ color: "white" }}>
                      {item.title}
                    </Link>
                  </Box>
                );
              })}
            </Stack>
            <Stack spacing={1.5}>
              {links.map((item, index) => {
                if (index < 3) {
                  return;
                }
                return (
                  <Box>
                    <Link to={item.link} style={{ color: "white" }}>
                      {item.title}
                    </Link>
                  </Box>
                );
              })}
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: isGreaterThanOrEqualMd ? "baseline" : "center",
                gap: ".5rem",
                flexDirection: isGreaterThanOrEqualMd ? "row" : "column",
                textAlign: "center",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, fontSize: "16px", flex: "none" }}
              >
                SignUp Our Newsletter
              </Typography>
              <StyledTextField
                variant="outlined"
                fullWidth
                sx={{
                  "& .Mui-focused": {
                    border: "none",
                  },
                  maxWidth: "300px",
                }}
                placeholder="Enter your email."
                slotProps={{
                  input: {
                    endAdornment: (
                      <Button
                        sx={{
                          height: "43px",
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                        }}
                        variant="contained"
                      >
                        Go
                      </Button>
                    ),
                  },
                }}
              />
            </Box>
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 3 }}
            sx={{
              display: isGreaterThanOrEqualMd ? "none" : "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 5,
              fontWeight: 500,
              marginTop: "15px",
            }}
          >
            <Stack spacing={1.5}>
              {links.map((item, index) => {
                if (index > 2) {
                  return;
                }
                return (
                  <Box>
                    <Link to={item.link} style={{ color: "white" }}>
                      {item.title}
                    </Link>
                  </Box>
                );
              })}
            </Stack>
            <Stack spacing={1.5}>
              {links.map((item, index) => {
                if (index < 3) {
                  return;
                }
                return (
                  <Box>
                    <Link to={item.link} style={{ color: "white" }}>
                      {item.title}
                    </Link>
                  </Box>
                );
              })}
            </Stack>
          </Grid2>
        </Grid2>
      </Box>
      <Box
        sx={{
          background: secondaryColor,
          color: primaryColor,
          padding: "10px",
          textAlign: "center",
          fontWeight: 600,
          cursor: "none",
        }}
      >
        &#169; Copyright 2023 | Tresor Micro Finance
      </Box>
    </>
  );
};
export default Footer;
